import {queryCustomerById, updateCustomerUserSimp,checkCustomerByIdAndPwd,updateCustomerUser} from '@/api/customerUser'
import md5 from "js-md5";


const customerUser ={


  actions: {
    //根據用戶id獲取用戶信息
    QueryCustomerById({commit}, id) {
      return new Promise((resolve, reject) => {
        queryCustomerById(id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //修改用戶信息
    UpdateCustomerUserSimp({commit}, customerInfo) {
      return new Promise((resolve, reject) => {
        updateCustomerUserSimp(customerInfo).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //个人中心修改用戶信息
    UpdateCustomerUser({commit}, customerInfo) {
      return new Promise((resolve, reject) => {
        updateCustomerUser(customerInfo).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

//根據用戶id和输入的密码验证
    CheckCustomerByIdAndPwd({commit}, obj) {

      console.log(obj)

        checkCustomerByIdAndPwd(obj.id.trim(), md5(md5(obj.value) + obj.value)).then(res=>{
          if(res.code==200){
            obj.callback()
          }else {
            obj.callback(new Error('请输入正确密码！'))
          }
        }).catch(error => {
          obj.callback(new Error(error))
        })



    },
  }
}
export default customerUser